registerComponent("templates/footer-redesign", function (component) {
/**
 * RODAPÉ DO DESIGN — um comportamento só: os itens que são `<button>` abrem os
 * modais de 2020 (ADR 0047), pelo MESMO contrato que o `templates/footer`
 * legado usa — um `CustomEvent('open')` na raiz do modal:
 *
 * · `[data-open-modal-docs="<aba>"]` ("Transparência") abre a aba do
 *   `modals/modal-docs`, com o nome dela em `detail`;
 * · `[data-open-modal-faq]` ("Ajuda e suporte") abre o `modals/modal-faq`.
 *
 * Os modais moram nos dois layouts; se um deles não estiver na página, o clique
 * não faz nada.
 *
 * @param {HTMLElement} component - o <footer class="rodape">
 * @param {Object} params
 */

const abrir = (nome, detail) => {
    const modal = document.querySelector(`[data-component-name="modals/${nome}"]`);

    if (modal) {
        modal.dispatchEvent(new CustomEvent('open', { detail }));
    }
};

component.addEventListener('click', (event) => {
    const docs = event.target.closest('[data-open-modal-docs]');

    if (docs) {
        abrir('modal-docs', docs.dataset.openModalDocs);
        return;
    }

    if (event.target.closest('[data-open-modal-faq]')) {
        abrir('modal-faq');
    }
});

});
